<mat-accordion>
  <mat-expansion-panel [expanded]="activePage === 1">
    <mat-expansion-panel-header>
      <mat-panel-title>
          <span class="fs-3">BESCHREIBUNG <i class="bi bi-arrow-right-short h4 arrow"></i></span>
        <mat-chip-listbox class="ms-2">
          <mat-chip-option *ngFor="let item of expandedItems">
            {{ item }}
          </mat-chip-option>
        </mat-chip-listbox>
      </mat-panel-title>
      <!-- workplace: {{selectedWorkplaceId}} - malfunction: {{malfunctionId}} - solution: {{malfunctionId}} -->
    </mat-expansion-panel-header>
    <div class="row bg-light rounded p-2 mb-2" *ngFor="let malfunction of malfunctions">
      <div class="col">
        <div class="row align-items-center">
          <div class="col col-auto">
            <input
              class="form-check-input" type="radio" name="malfunction"
              [attr.data-index] = malfunction.id
              [attr.data-name] = malfunction.name
              (click)="selectMalfunction($event.target)"
            />
          </div>
          <div class="col">
            <h4 class="p-0 m-0">
                {{malfunction.name}}
            </h4>
            <p class="p-0 m-0 text-secondary">
              {{malfunction.description}}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="row bg-light rounded p-2 mb-2" *ngIf="selectedWorkplaceId && categoryId">
      <div class="col col-auto">
        <div class="row">
          <span>Es sind noch keine Fehlermeldungen vorhanden.</span>
          <a class="fs-4 text-blue text-decoration-none" role="button" (click)="openOffcanvas(malfunction)">+ Neue Beschreibung erstellen</a>
        </div>
      </div>
    </div>
  </mat-expansion-panel>
</mat-accordion>

<ng-template #malfunction let-offcanvas>
    <div class="offcanvas-header">
        <h4 class="offcanvas-title">Beschreibung erstellen</h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="offcanvas.dismiss('Cross click')"></button>
    </div>
    <div class="offcanvas-body">
        <form #malfunction="ngForm" (ngSubmit)="insertMalfunction(malfunction.value)" class="form">
            <input type="text" name="name" placeholder="Name" class="form-control mb-2" id="mName" aria-describedby="Malfunction Name" ngModel>
            <textarea rows="5" name="description" placeholder="Beschreibung" class="form-control mb-2" id="mDescription" aria-describedby="Malfunction Description" ngModel></textarea>
            <input type="submit" value="Erstellen" class="btn btn-primary float-end">
        </form>
    </div>
</ng-template>
